export interface AuditLog {
  id: string;
  tenantId: string | null;
  userId: string | null;
  userEmail: string | null;
  action: string;
  entityType: string;
  entityId: string;
  oldValues: string | null;
  newValues: string | null;
  ipAddress: string | null;
  serviceName: string | null;
  timestamp: string;
}

export interface AuditLogFilter {
  action?: string;
  entityType?: string;
  userEmail?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  pageSize?: number;
}

export const auditActionColors: Record<string, { bg: string; text: string; border: string }> = {
  Create: { bg: 'bg-emerald-500/10', text: 'text-emerald-400', border: 'border-emerald-500/20' },
  Update: { bg: 'bg-blue-500/10', text: 'text-blue-400', border: 'border-blue-500/20' },
  Delete: { bg: 'bg-red-500/10', text: 'text-red-400', border: 'border-red-500/20' },
};
